import gql from "graphql-tag";

export const GET_LAST_TRANSACTION = gql`
query last_transactions(
  $search_text: String
  $profile_id: uuid!
  $limit: Int
  $order_by: [business_council_last_transactions_order_by!] = {}
) {
  business_council_last_transactions(
    where: {
      _or: [
        {business_profile_id: { _eq: $profile_id }},
        {club_profile_id: { _eq: $profile_id }}
       ]
      _and: [
        { full_name: { _ilike: $search_text } }
      ]
    }
    order_by: $order_by
    limit: $limit
  ) {
    created_at
    event_name
    business_profile_id
    club_profile_id
    full_name
    purchased_price
    quantity
    option_name
  }
}
`;
